<template>
  <div class="box">
    <div>
      <p>{{ proName }}</p>
    </div>
    <div class="title">
      <span>Legend：</span>
      <img :src="iconUrl" />
      <span>Area</span>
    </div>
    <tdt-map
       ref="map"
      :center="center"
      :zoom="zoom"
      :drag="false"
      :scrollWheelZoom="false"
      :doubleClickZoom="false"
      :keyboard="false"
      :inertia="false"
      :continuousZoom="false"
      :pinchToZoom="false"
    >
      <!-- <tdt-polyline
        :path="path"
        :edit="false"
        color="black"
        :opacity="1"
        lineStyle="solid"
      ></tdt-polyline> -->
      <!-- <div v-if="showCity">
        <tdt-polygon
          v-for="(item, index) in cityListArr"
          :key="index"
          :path="item.path"
          :edit="false"
          color="black"
          :opacity="1"
          fillColor="red"
          :fillOpacity="1"
          @click="mapClick(item)"
          @mouseover="
            (e) => {
              MapMousemove(e, item);
            }
          "
          @mouseout="
            (e) => {
              MapMouseout(e, item);
            }
          "
        ></tdt-polygon>
      </div>
      <div v-else> -->
      <tdt-marker
        v-for="(item, index) in cityListArr"
        :key="index"
        :position="item.center"
        :icon="icon"
        :zIndexOffset="0"
        @click="mapClick(item)"
        @mouseover="
          (e) => {
            MapMousemove(e, item);
          }
        "
        @mouseout="
          (e) => {
            MapMouseout(e, item);
          }
        "
      ></tdt-marker>
      <!-- </div> -->
      <tdt-label
        :zIndex="9999"
        :position="titleCenter"
        :text="titleName"
        :offset="[-110, -125]"
        v-if="isShow"
      ></tdt-label>
    </tdt-map>
  </div>
</template>

<script>
export default {
  props: {
    center: {
      type: Array,
      default() {
        return [];
      },
    },
    zoom: {
      type: Number,
      default: 7,
    },
    path: {
      type: Array,
      default() {
        return [];
      },
    },
    cityListArr: {
      type: Array,
      default() {
        return [];
      },
    },
    showCity: {
      type: Boolean,
      default: true,
    },
    icon: {
      type: Object,
      default() {
        return {};
      },
    },
    province: {
      type: String,
      default: "",
    },
    proName: {
      type: String,
      default: "Shanghai FTZ",
    },
  },
  data() {
    return {
      isShow: false,
      iconUrl: require("../../../assets/images/biaodian.svg"),
    };
  },
  methods: {
    mapClick(obj) {
      // console.log(obj)
      this.$router.push({
        name: "FtaAreaInfo",
        query: {
          provinceId: this.province,
          city: obj.id,
        },
      });
      // console.log(evt)
      // 创建对象
      // geocode = new T.Geocoder();

      // new T.Geocoder().getLocation(evt.lnglat, (result) => {
      //   console.log(result.addressComponent)
      //   this.provinceList.forEach((item) => {
      //     // console.log(item.val)
      //     if (
      //       item.val.indexOf(
      //         result.addressComponent.province.substring(0, 2)
      //       ) != -1
      //     ) {
      //       this.provinceId = item.id
      //       // console.log(1)
      //     }
      //   })
      //   // 获取省/直辖市下拉框信息

      //   // 获取市下拉框信息
      //   // 判断点击的地点是否是下一个片区的存在自贸区
      //   request('get', `/ftaInfoArea/queryAreaByFtaId/${this.provinceId}`).then(
      //     (res) => {
      //       console.log(res)
      //       this.cityList = res.data
      //       this.cityList.forEach((item) => {
      //         if (
      //           item.val.indexOf(
      //             result.addressComponent.city.substring(0, 2)
      //           ) != -1
      //         ) {
      //           this.city = item.id
      //         }
      //       })
      //       console.log(this.provinceId, this.city)
      //       if (this.city && this.provinceId) {
      //         this.$router.push({
      //           name: 'FtaAreaInfo',
      //           query: {
      //             provinceId: this.provinceId,
      //             city: this.city
      //           }
      //         })
      //       }
      //     }
      //   )
      // })
    },
    MapMousemove(e, item) {
      // console.log(e)

      this.isShow = true;
      // var titleContent = document.querySelector(".tdt-label");
      this.titleName = `<div style="position: relative;z-index:100">
                      <div
                          style="background: #fff; padding: 8px 15px;box-shadow: 1px 1px 5px rgba(0,0,255,.5); ">
                          <p style="margin: 0; color: #000; font-size: 14px;font-weight: 600">${item.val}</p>
                          <p style="margin: 0; color: #000; font-size: 12px;">
                             Foundation date:
                              <span style="color: #0073FF">
                                 ${item.establishDate?item.establishDate:'No Data'}
                              </span>
                          </p>
                                   <p style="margin: 0; color: #000; font-size: 12px;">
                             Surface:
                              <span style="color: #0073FF">
                                  ${item.area?item.area:'No Data'}${item.area?'km²':''}
                              </span>

                          </p>
                      </div>
                      <div style="position: absolute; bottom: 0; left: 0; width: 100%; z-index: 3; height: 10px; background: #fff; border-radius: 4px;"></div>
                      <div style="position: absolute; bottom: -5px; left: 50%; z-index: 2; margin-left: -5px; width: 10px; height: 10px; background: #fff; transform: rotate(135deg); box-shadow: 0 2px 4px 0 rgba(0,0,0,0.20);"></div>
                  </div> `;
      // console.log(titleContent);
      this.titleCenter = [
        e.lnglat.getLng().toFixed(6),
        e.lnglat.getLat().toFixed(6),
      ];
      // titleContent.style.left = e.originalEvent.clientX + "px";
      // titleContent.style.bottom = e.originalEvent.clientY + "px";
    },
    MapMouseout(e, item) {
      this.isShow = false;
      this.titleName = `<div style="position: relative;">
                      <div
                          style="background: #fff; padding: 8px 15px; ">
                          <p style="margin: 0; color: #000; font-size: 14px;font-weight: 600">${item.val}</p>
                          <p style="margin: 0; color: #000; font-size: 12px;">
                             Foundation date:
                              <span style="color: #0073FF">
                                 ${item.establishDate?item.establishDate:'No Data'}
                              </span>
                          </p>
                                   <p style="margin: 0; color: #000; font-size: 12px;">
                              Foundation date:
                              <span style="color: #0073FF">
                                  ${item.area?item.area:'No Data'}${item.area?'km²':''}
                              </span>

                          </p>
                      </div>
                      <div style="position: absolute; bottom: 0; left: 0; width: 100%; z-index: 3; height: 10px; background: #fff; border-radius: 4px;"></div>
                      <div style="position: absolute; bottom: -5px; left: 50%; z-index: 2; margin-left: -5px; width: 10px; height: 10px; background: #fff; transform: rotate(135deg); box-shadow: 0 2px 4px 0 rgba(0,0,0,0.20);"></div>
                  </div> `;
    },
  },
  mounted(){
        var map_ter =  new T.TileLayer("http://t0.tianditu.gov.cn/vec_w/wmts?" +
            "SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles" +
            "&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}" +
            "&tk=ed564f9c0ee383bb453cd76d135c8fee")

    var map_cta =  new T.TileLayer("http://t0.tianditu.gov.cn/eva_w/wmts?" +
             "SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=eva&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles" +
             "&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}" +
             "&tk=ed564f9c0ee383bb453cd76d135c8fee")
    this.$nextTick(()=>{
     setTimeout(() => {
     let map = this.$refs.map.getMap()
      //  console.log(this.$refs.map.getMap(),777)

       map.addLayer(map_ter)
       map.addLayer(map_cta)

     }, 100);
    })
  }
};
</script>

<style scoped>
.box {
  width: 100%;
  height: 100%;
}
.box > div:nth-of-type(1) {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 1000;
  width: 177px;
  height: 31px;
  background-image: linear-gradient(
    90deg,
    #64d1ff 40%,
    rgba(52, 164, 255, 0.4) 100%
  );
}
.box > div:nth-of-type(1) > p {
  /* font-family: SourceHanSansCN-Normal; */
  font-size: 14px;
  color: #000000;
  letter-spacing: -0.28px;
  font-weight: 400;
  line-height: 31px;
  float: left;
  margin-left: 10px !important;
}
.title {
  width: 142px;
  height: 43px;
  background: #ffffff;
  border: 1px solid #d0d0d0;
  border-radius: 2px;
  position: absolute;
  z-index: 1000;
  bottom: 15px;
  left: 25px;
  padding-left: 20px;
  box-sizing: border-box;
  line-height: 43px;
}
.title img {
  width: 20px;
  height: 20px;
  margin-right: 6px;
  margin-top: -2px;
}
.title span {
  /* font-family: SourceHanSansCN-Regular; */
  font-size: 12px;
  color: #000000;
  letter-spacing: -0.24px;
  font-weight: 400;
}
.title span > :nth-of-type(1) {
  margin-right: 15px;
}
</style>
<style>
.tdt-pane.tdt-overlay-pane {
  z-index: 9999 !important;
}
.tdt-label{
  padding: 0 !important;
}
</style>
